import { Children, cloneElement, isValidElement, } from 'react';
import { useStyles, } from '../../index.js';
export const Elevator = ({ children, resting, direction = 'bottom', shadowColor = 'oklch(0% 0 0)', extraShadow, hover, }) => {
    const { elevation } = useStyles({
        elevation: {
            resting,
            onHover: hover,
            direction,
            shadowColor: shadowColor || undefined,
        },
    });
    return Children.map(children, child => isValidElement(child) && cloneElement(child, {
        ...elevation.attributes,
        style: {
            ...child.props.style,
            ...elevation.style,
            '--extra-shadow': extraShadow,
        },
    }));
};
